import React from 'react'

import { type HeaderProps } from './ScoreCardType'
import styles from './_score-card.module.scss'

const Header = ({ title, subtitle }: HeaderProps) => {
  return (
    <div className={styles.headerWrap}>
      <div className={styles.headerTitle}>{title}</div>
      {subtitle ? (
        <div className={styles.headerSubtitle}>{subtitle}</div>
      ) : null}
    </div>
  )
}

export default Header
